<template>
  <div class="contactus">
    <!-- <div class="way">
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :span="20">
          <breadcrumb></breadcrumb>

        </el-col>
      </el-row>
    </div> -->
    <p class="title">联系我们</p>
    <el-row type="flex" class="row-bg block" justify="center">
      <img src="@/assets/images/lianxiwomen.png" alt="" />
      <!--<div class="address">
        <div class="kuang">
          <img
            src="http://ows-oss.oss-cn-shanghai.aliyuncs.com/test/20190613110658.png?Expires=4713995218&OSSAccessKeyId=LTAInsXrJwCtS2CU&Signature=SYgn4KPsFQ1YUNpnD5gp8HiMRQ8%3D"
            alt=""
          />
          <h4>公司：</h4>
          <p>壹米滴答供应链集团有限公司</p>
          <h4>地址：</h4>
          <p>上海市青浦区华徐公路685号E通世界南区B座12楼</p>
        </div>
        <div class="jiao"></div>
      </div>-->
    </el-row>
  </div>
</template>
<script>
// import BMap from "BMap";
import breadcrumb from "@/components/breadcrumb";
// import { BaiduMap } from "@/map/map.js";
export default {
  components: {
    breadcrumb,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    // this.$nextTick(function() {
    //     BaiduMap.init().then(BMap => {
    //         let map = new BMap.Map(this.$refs.allmap); // 创建Map实例
    //         map.centerAndZoom(new BMap.Point(121.272596, 31.202192), 12); // 初始化地图,设置中心点坐标和地图级别
    //         map.addControl(
    //             new BMap.MapTypeControl({
    //                 //添加地图类型控件
    //                 mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
    //             })
    //         );
    //         map.setCurrentCity("上海"); // 设置地图显示的城市 此项是必须设置的
    //         map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    //         var icon = new BMap.Icon(
    //             require("@/assets/images/tubiao.png"),
    //             new BMap.Size(30, 40)
    //         );
    //         //设置标注的经纬度
    //         var marker = new BMap.Marker(
    //             new BMap.Point(121.272596, 31.202192),
    //             {
    //                 icon: icon
    //             }
    //         );
    //         //把标注添加到地图上
    //         map.addOverlay(marker);
    //         var content =
    //             "<div style='width:360px;'>" +
    //             "<img style='' src='http://ows-oss.oss-cn-shanghai.aliyuncs.com/test/20190614053544.jpg?Expires=4714104944&OSSAccessKeyId=LTAInsXrJwCtS2CU&Signature=fUGV1GgzvJj63uG0K%2F0bPxj4tTY%3D' width='339' height='104'/>" +
    //             "<div><h2 style='color:#333;font-size:16px;margin: 8px 0 10px;'>公司：</h2><p style='color:#555555;font-size:16px;margin: 8px 0;'>壹米滴答供应链集团有限公司</p></div>" +
    //             "</div>" +
    //             "<div><h2 style='color:#333;font-size:16px;margin: 8px 0 10px;'>地址：</h2><p style='color:#555555;font-size:16px;margin: 8px 0;'>上海市青浦区华徐公路685号E通世界南区B座12楼</p></div>" +
    //             "</div>";
    //         var infowindow = new BMap.InfoWindow(content);
    //         marker.addEventListener("click", function() {
    //             this.openInfoWindow(infowindow);
    //         });
    //         marker.openInfoWindow(infowindow);
    //     });
    // });
  },
};
</script>

<style lang="scss" scoped>
.contactus {
  .way {
    height: 50px;
    margin-top: -3px;
    background-color: #221814;
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .block {
    margin-bottom: 40px;
    position: relative;
    img {
      width: 100%;
    }
    .address {
      position: absolute;
      bottom: 22%;
      border-radius: 6px;
      z-index: 99;
      width: 380px;
      height: 200px;
      background-color: #fff;
      box-shadow: 4px 2px 4px rgba(0, 0, 0, 0.12), 0 4px 6px rgba(0, 0, 0, 0.04);
      .kuang {
        margin: 20px;
        h4 {
          margin: 6px 0;
        }
        p {
          font-size: 15px;
        }
      }
      .jiao {
        background-color: #fff;
        position: absolute;
        left: 173px;
        bottom: 0px;
      }
      .jiao:after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        width: 0;
        height: 0;
        border-width: 18px 20px 0;
        border-style: solid;
        border-color: #fff transparent transparent;
      }
    }
    // .alone {
    //     // border: 1px solid #ccc;
    //     text-align: center;
    //     padding: 0 6px;
    //     .border {
    //         border: 1px solid #ccc;
    //         img {
    //             margin-top: 40px;
    //             text-align: center;
    //         }
    //         .head {
    //             font-size: 20px;
    //             margin-top: 24px;
    //         }
    //         .emal {
    //             font-size: 14px;
    //             color: #666;
    //             margin-top: 23px;
    //         }
    //         .tele {
    //             font-size: 25px;
    //             margin-top: 24px;
    //             margin-bottom: 39px;
    //         }
    //     }
    // }
  }
  .contact {
    text-align: center;
    .cont {
      margin-top: 80px;
      font-size: 24px;
    }
    img {
      margin-top: 19px;
    }
    .iphone {
      font-size: 30px;
      margin-top: 23px;
    }
    .code {
      font-size: 18px;
      margin: 18px 0 58px 0;
    }
  }
  ::v-deep .map {
    // width: 100%;
    height: 500px;
    margin: 60px 0;
    // overflow: hidden;
    .BMap_pop {
      // position: absolute;
      // top: 13px !important;
      // display: block !important;
    }
    #allmap {
      height: 500px;
    }
    .BMap_pop .BMap_center,
    .BMap_pop .BMap_top {
      border: none;
    }
    .BMap_pop div:nth-child(1) {
      border-radius: 7px 0 0 0;
      border: none !important;
    }
    .BMap_pop div:nth-child(3) {
      border-radius: 0 7px 0 0;
      border: none !important;
      width: 23px !important;
    }
    .BMap_pop div:nth-child(3) div {
      border-radius: 7px;
      border: none !important;
    }
    .BMap_pop div:nth-child(5) {
      border-radius: 0 0 0 7px;
      border: none !important;
    }
    .BMap_pop div:nth-child(5) div {
      border-radius: 7px;
      border: none !important;
    }
    .BMap_pop div:nth-child(7) {
      border-radius: 0 0 7px 0;
      border: none !important;
      width: 23px !important;
    }
    .BMap_pop div:nth-child(7) div {
      border-radius: 7px;
      border: none !important;
    }
    .anchorBL {
      // display: none;
    }
  }
}
</style>
